// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3LFQI","item":"PaymentsMobile_item__2VGrB","label":"PaymentsMobile_label__2rWBv","amount":"PaymentsMobile_amount__2PPYS"};